<template>
  <v-app>
    <header>
      <v-app-bar app dark density="compact"
        ><!-- 相対パスの画像がなぜか効かない -->
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-toolbar-title
          >CAGE
          <span class="text-caption"
            >- {{ router.currentRoute.value.name }} -</span
          ></v-toolbar-title
        >
        <v-btn
          @click="userStore.confirmAllowNotification()"
          v-if="userStore.notificationPermit === 'default'"
        >
          通知を許可
        </v-btn>
        <v-btn
          @click="userStore.login()"
          v-if="!userStore.isLoggedIn"
          prepend-icon="mdi-login"
        ></v-btn>
        <v-btn
          @click="userStore.logout()"
          v-if="userStore.isLoggedIn"
          prepend-icon="mdi-logout"
        ></v-btn>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-list nav dense>
          <v-list-item-group>
            <v-list-item
              v-for="tab in enableTabList"
              :key="tab.tabName"
              :value="tab.tabName"
              @click="moveTo(tab.tabPath)"
              :prepend-icon="tab.icon"
            >
              <v-list-item-title>{{ tab.tabName }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              value="LOGIN"
              @click="userStore.login()"
              v-if="!userStore.isLoggedIn"
              prepend-icon="mdi-login"
              ><v-list-item-title>LOGIN</v-list-item-title></v-list-item
            >
            <v-list-item
              @click="userStore.logout()"
              v-if="userStore.isLoggedIn"
              prepend-icon="mdi-logout"
              ><v-list-item-title>LOGOUT</v-list-item-title></v-list-item
            >
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </header>
    <v-main><router-view /></v-main>

    <div class="loader-wrap" v-if="systemStore.isLoading">
      <div class="loader">loading</div>
      {{ !$vuetify.display.mdAndUp ? "" : "REFRESH" }}
    </div>
    <footer>
      <v-bottom-navigation density="compact">
        <v-btn @click="refresh()">
          <v-icon>mdi-refresh</v-icon>
          REFRESH
        </v-btn>
        <v-btn
          v-for="tab in bottomeTabList"
          :key="tab.tabName"
          :value="tab.tabName"
          @click="moveTo(tab.tabPath)"
        >
          <v-icon>{{ tab.icon }}</v-icon>
          {{ tab.tabName }}
        </v-btn>
      </v-bottom-navigation>
    </footer>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<script setup lang="ts">
import { ref, computed, shallowRef } from "vue";
import { useSystemStore } from "./store/system-store";
import { useUserStore } from "./store/user-store";
import router from "./router";

const systemStore = useSystemStore();
const userStore = useUserStore();

const drawer = ref(false);
const tab = ref(null);
const tabList = ref([
  {
    tabName: "HOME",
    icon: "mdi-home-variant-outline",
    tabPath: "/",
    requireAuth: false,
    bottom: true,
  },
  {
    tabName: "NEWS",
    icon: "mdi-newspaper-variant-outline",
    tabPath: "news",
    requireAuth: false,
    bottom: true,
  },
  {
    tabName: "MARKET",
    icon: "mdi-chart-line",
    tabPath: "market",
    requireAuth: false,
    bottom: true,
  },
  {
    tabName: "LOG",
    icon: "mdi-file-document-multiple-outline",
    tabPath: "log",
    requireAuth: true,
    bottom: false,
  },
  {
    tabName: "JOB",
    icon: "mdi-calendar-check-outline",
    tabPath: "job",
    requireAuth: true,
    bottom: false,
  },
  {
    tabName: "CHART",
    icon: "mdi-calendar-check-outline",
    tabPath: "plotlychart",
    requireAuth: true,
    bottom: false,
  },
  {
    tabName: "SIM",
    icon: "mdi-chart-box-plus-outline",
    tabPath: "simulation",
    requireAuth: false,
    bottom: true,
  },
]);

const enableTabList = computed(() => {
  return tabList.value.filter((tab) => {
    return !tab.requireAuth || (tab.requireAuth && userStore.isLoggedIn);
  });
});

const bottomeTabList = computed(() => {
  return tabList.value.filter((tab) => {
    return (
      tab.bottom &&
      (!tab.requireAuth || (tab.requireAuth && userStore.isLoggedIn))
    );
  });
});

const moveTo = async (to: string) => {
  router.replace(to);
};

const open = shallowRef(false);

const refresh = () => {
  router.go(0);
};
</script>
